/* eslint-disable */

export const state = () => ({
  socketPersistName: '',
  socketPersistNameChat: '',
  isSocketConnected: false,
  isSocketChatConnected: false,
  isDoctorReconnect: false,
  isAuthorized: false
})

export const getters = {
  getStatusSocketConnected: (state) => {
    return state.isSocketConnected
  }
}

export const mutations = {
  SET_SOCKET_PERSIST_NAME: (state, value) => {
    state.socketPersistName = value
  },

  SET_SOCKET_PERSIST_NAME_CHAT: (state, value) => {
    state.socketPersistNameChat = value
  },

  CONNECT: (state, value) => {
    state.isSocketConnected = value
  },

  SET_CONNECT_SOCKET_CHAT: (state, value) => {
    state.isSocketChatConnected = value
  },

  SET_IS_DOCTOR_RECONNECT: (state, value) => {
    state.isDoctorReconnect = value
  },

  SET_IS_AUTHORIZED: (state, value) => {
    state.isAuthorized = value
  }
}

export const actions = {
  authorization ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      console.log('[GLOBAL SOCKET] Authorizing...', state.socketPersistName, rootState.user.auth.token)
      dispatch(
        '$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'Authorization',
          msg: rootState.user.auth.token,
        }, { root: true }
      ).then((resEmit) => {
        console.log('[GLOBAL SOCKET] Authorized:', resEmit)
        commit('SET_IS_AUTHORIZED', true)
        dispatch('emitLsLog')
        resolve(true)
      }).catch((errorEmit) => {
          console.log('[GLOBAL SOCKET] Failed Authorized')
        reject(errorEmit)
      })
    })
  },
  log ({ dispatch, rootState, state }, payload) {
    const {data, status = 'INFO', consoleLog = true, fromLS = false} = payload
    return new Promise((resolve, reject) => {
      const message = `[${$nuxt.$moment().format('YYYY-MM-DD HH:mm:ss')}]${state.isAuthorized ? '' : ' [FROM LS]'} [${status}] ${data}`
      if(consoleLog) console.log(message)
      if (state.isAuthorized) {
        dispatch(
          '$nuxtSocket/emit',
          {
            label: rootState.globalSocket.socketPersistName,
            evt: 'DoctorPanelLogs',
            msg: {
              tokenLoginId: rootState.user.auth.token,
              message: fromLS ? data : message
            }
          }, { root: true }
        ).then((resEmit) => {
          console.log('[DOCTOR PANEL LOG]', data)
          resolve(true)
        }).catch((errorEmit) => {
          console.log('[LOGGING FAILED]', data)
          reject(errorEmit)
        })
      } else {
        const lsData = JSON.parse(localStorage.getItem('offline_log'))
        const data = lsData ? [...lsData, message] : [message]
        localStorage.setItem('offline_log', JSON.stringify(data))
      }
    })
  },
  emitLsLog ({ dispatch }) {
    const offlineLogs = JSON.parse(localStorage.getItem('offline_log'))
    if (offlineLogs) {
      offlineLogs.forEach((item) => {
        dispatch('log', { data: item, fromLS: true })
      })
      localStorage.removeItem('offline_log')
    }
  },
  authorizationSocketChat ({ dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistNameChat,
          evt: 'authorize',
          msg: {
            type: 'DOCTOR',
            actor: btoa(rootState.user.auth.userData.ID)
          }
        },
        { root: true }
      ).then((resEmit) => {
        resolve(true)
      }).catch((errorEmit) => {
        reject(errorEmit)
      })
    })
  },
  setBroadcastChat ({ dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistNameChat,
          evt: 'broadcast',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setNewTicketHelpdesk ({ dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistNameChat,
          evt: 'need_action',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorRemind ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorRemind',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorRequestConsultation ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorRequestConsultation',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorConnectConsultation ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorConnectConsultation',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorTimerBeforeConsultation ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorTimerBeforeConsultation',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorTimerAfterConsultation ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorTimerAfterConsultation',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorStartPractice ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorStartPractice',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorCalling ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorCalling',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorStandby ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorStandby',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorAccessMicrophone ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorAccessMicrophone',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setDoctorAccessCamera ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'DoctorAccessCamera',
          msg: payload
        },
        { root: true }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
}
